import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { FatturaForm } from '../../../form/fattura-form';
import { SezioneFattureResponse } from '../../../models/dto/sezione-fatture-response';
import { Fattura } from '../../../models/fattura';
import { SezioneFatture } from '../../../models/sezioni/sezione-fatture';
import { FormValidationService } from '../../../services/form-validation.service';

@Component({
    selector: 'div [fattura-form-add]',
  templateUrl: '../../../form/fattura-form.html'
})

export class FattureAddComponent extends FatturaForm {
  private idSezione: string;
  private idFascicolo: string;
  private urlInsert: string;
  private urlReadSezioneAltreParti: string;

  @Output() onReturn: EventEmitter<SezioneFatture> = new EventEmitter<SezioneFatture>();

  constructor(@Inject(OperationsService) operationService,
              @Inject(FormBuilder) campiForm,
              @Inject(HelpersService) helpers: HelpersService,
              @Inject(FormValidationService) formValidationService: FormValidationService) {
        super(operationService, campiForm, helpers, formValidationService);
  }

  ngOnInit() {
    this.setTitle('Aggiungi Fattura');
    this.isInserimento(true);
  }

  getFattura() {
    return new Fattura();
  }

  getUrlReadSezioneAltreParti() {
    return this.urlReadSezioneAltreParti;
  }

  getRequest(request: Fattura) {
    this.operationService.addFattura(this.urlInsert, request, this.idSezione, this.idFascicolo).subscribe((response: any) => this.datiFattura(response));
  }

  datiFattura(response: SezioneFattureResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(idSezione: string, idFascicolo: string, idSezioneAltreParti: string, urlInsert: string, urlReadSezioneAltreParti: string) {
    this.idSezione = idSezione;
    this.idFascicolo = idFascicolo;
    this.urlInsert = urlInsert;
    this.urlReadSezioneAltreParti = urlReadSezioneAltreParti;
    if (idSezioneAltreParti) {
      this.readSezioneAltreParti(idSezioneAltreParti);
    } else {
      this.msgNoBeneficiari = 'Non esistono beneficiari da associare';
    }
    this.createForm();
    this.populateSelect();
  }

}
